import React from 'react'

import {OmicsAssistantMessageParts} from '../OmicsAssistantMessageParts'

/**
 * Omics assistant body: `MessagePrimitive.GroupedParts` Chain of Thought + tool UIs.
 */
export const AssistantMessageBody: React.FC = () => {
  return <OmicsAssistantMessageParts />
}
